import React, { useState } from 'react'
import Navbar from '../../Navbar'
import Sidebar from '../../Sidebar'

import { InfoContainer, InfoWrapper, SectionTitle } from './GovernanceElements'

const Governance = () => {
  const [isOpen, setIsOpen] = useState(false)

  const toggle = () => {
    setIsOpen(!isOpen)
  }
  return (
    <>
      <Navbar toggle={toggle} info='Community' />
      <Sidebar isOpen={isOpen} toggle={toggle} info='Community' />
      <InfoContainer>
        <InfoWrapper>
          <SectionTitle>Governance</SectionTitle>
        </InfoWrapper>
      </InfoContainer>
    </>
  )
}

export default Governance
